import React from 'react';
import { useTranslation } from 'react-i18next';
import './MemberHome.css';

/* Shared type-aware renderer for Bravos assessment questions — used by both the member survey
   (BravosSurvey) and the public distributed assessment (BravosAssess). Question types come from
   the API: scale (1-5), choice ({value,label} options), text, or unsupported (shown disabled). */

const ScaleField = ({ q, value, onChange }) => (
  <div className="bravos-q">
    <p className="bravos-q__text">{q.text}</p>
    <div className="bravos-scale">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          type="button" key={n}
          className={`bravos-scale__btn ${value === n ? 'is-on' : ''}`}
          onClick={() => onChange(n)}
        >
          {n}
        </button>
      ))}
    </div>
    {q.anchors && <p className="bravos-q__hint">{q.anchors}</p>}
  </div>
);

const ChoiceField = ({ q, value, onChange }) => (
  <div className="bravos-q">
    <p className="bravos-q__text">{q.text}</p>
    <div className="bravos-choices">
      {(q.options || []).map((o) => (
        <button
          type="button" key={o.value}
          className={`bravos-choice ${value === o.value ? 'is-on' : ''}`}
          onClick={() => onChange(o.value)}
        >
          {o.label}
        </button>
      ))}
    </div>
  </div>
);

const TextField = ({ q, value, onChange }) => (
  <div className="bravos-q">
    <p className="bravos-q__text">{q.text}</p>
    <textarea
      className="bravos-textarea" rows={3} value={value || ''}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

const BravosQuestions = ({ questions, answers, setAnswer }) => {
  const { t } = useTranslation();
  return (
    <>
      {(questions || []).map((q) => {
        const onChange = (v) => setAnswer(q.id, v);
        if (q.type === 'scale') {
          return <ScaleField key={q.id} q={q} value={answers[q.id]} onChange={onChange} />;
        }
        if (q.type === 'choice') {
          return <ChoiceField key={q.id} q={q} value={answers[q.id]} onChange={onChange} />;
        }
        if (q.type === 'text') {
          return <TextField key={q.id} q={q} value={answers[q.id]} onChange={onChange} />;
        }
        // Unsupported (choice items whose options aren't seeded yet) — shown disabled.
        return (
          <div key={q.id} className="bravos-q bravos-q--disabled">
            <p className="bravos-q__text">{q.text}</p>
            <p className="bravos-q__hint">{t('comingSoon')}</p>
          </div>
        );
      })}
    </>
  );
};

export default BravosQuestions;
